import {h, Fragment} from "preact"
import { usePagination, useActions } from "@nosto/preact"

export default function Pagination() {
    const { prev, first, pages, last, next } = usePagination({ width: 5 });
    const { updateSearch } = useActions();

    function setPageCallback({ from }) {
        return () => {
            updateSearch({ products: { from } })
            scrollTo({ top: 0, behavior: 'smooth' })
        }
    }

    return (
        <ul className="flex justify-center items-center pb-5" role="navigation">
            {prev && (
                <li>
                    <button 
                        className="w-[1.625rem]" 
                        type="button" 
                        onClick={setPageCallback(prev)} 
                        aria-label="Previous" 
                        tabIndex={1}
                    >
                        <svg viewBox="0 0 7 14" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label="Arrow pointing left" class="w-1.5 h-3">
                            <path d="M6.5 13.0001L0.5 7.00012L6.5 1.00012" stroke="#2D2926" stroke-miterlimit="16" stroke-linecap="round" stroke-linejoin="round"></path>
                        </svg>
                    </button>
                </li>
            )}
            {/* {first && (
                <li>
                    <button className="" type="button" onClick={setPageCallback(first)} aria-label="First" tabIndex={2}>
                        {first.page}
                    </button>
                </li>
            )} */}
            {/* {first && (
                <li aria-hidden="true">
                    <span className="">...</span>
                </li>
            )} */}
            {pages.map((page, index) => (
                <li key={index} aria-current={page.current ? 'page' : undefined} >
                    <button
                        className={`block w-10 text-center ${page.current ? "font-medium pointer-default pointer-events-none" : ""}`}
                        type="button" 
                        aria-label={`Navigate to page ${page.page}`}
                        onClick={setPageCallback(page)}
                        disabled={page.current}
                        aria-disabled={page.current ? 'true' : undefined}
                        tabIndex={first ? index + 2 : index + 1}
                    >
                        {page.page}
                    </button>
                </li>
            ))}
            {/* {last && (
                <li aria-hidden="true">
                    <span className="">...</span>
                </li>
            )} */}
            {/* {last && (
                <li>
                    <button className="" type="button" onClick={setPageCallback(last)} aria-label="Last" tabindex={pages.length + 3}>
                        {last.page}
                    </button>
                </li>
            )} */}
            {next && (
                <li>
                    <button 
                        className="block w-[1.625rem] rotate-180" 
                        type="button" 
                        onClick={setPageCallback(next)} 
                        aria-label="Next" 
                        tabindex={last ? pages.length + 2 : pages.length + 1}
                    >
                        <svg viewBox="0 0 7 14" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label="accessibility.right" class="w-1.5 h-3">
                            <path d="M6.5 13.0001L0.5 7.00012L6.5 1.00012" stroke="#2D2926" stroke-miterlimit="16" stroke-linecap="round" stroke-linejoin="round"></path>
                        </svg>
                    </button>
                </li>
            )}
        </ul>
    )
}
